import { render, staticRenderFns } from "./SalaryBanks.vue?vue&type=template&id=3775169f&scoped=true&"
import script from "./SalaryBanks.vue?vue&type=script&lang=js&"
export * from "./SalaryBanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3775169f",
  null
  
)

export default component.exports